import { render, staticRenderFns } from "./ModalConfirmPublish.vue?vue&type=template&id=07d7774c&"
import script from "./ModalConfirmPublish.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmPublish.vue?vue&type=script&lang=js&"
import style0 from "./ModalConfirmPublish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports